module.exports = __webpack_public_path__ + "static/mielona_stosik-d82f9483f401c506dafb9843973b2d63.png";